import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "@/data/site";

/**
 * Hero - "Effortless Beauty, Every Day" editorial layout (matches brand mockup).
 * Live text on the left, model photo bleeding from the right on black.
 * Same layout on mobile and desktop.
 */
export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-onyx" aria-label="Welcome to Golden Touch Lash and Brow">
      <h1 className="sr-only">
        Golden Touch Lash and Brow - Effortless Beauty, Every Day. Lash, brow and beauty services in
        Vero Beach, Florida.
      </h1>

      <img
        src={IMAGES.heroModel}
        alt="Model with full volume lash extensions and defined brows by Golden Touch Lash and Brow"
        width={1254}
        height={1254}
        fetchPriority="high"
        decoding="async"
        className="pointer-events-none absolute right-0 top-0 h-[84%] w-[64%] object-cover object-[center_top] sm:h-full sm:w-[52%] lg:w-[48%]"
        style={{ filter: "brightness(1.12) saturate(1.05)" }}
      />
      {/* feather the photo into black on the left */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-onyx via-onyx/70 to-transparent sm:via-onyx/60 lg:via-onyx/45" />
      {/* feather the photo into black along the bottom */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[34%] bg-gradient-to-t from-onyx via-onyx/40 to-transparent" />
      <div className="pointer-events-none absolute -top-40 right-0 h-[26rem] w-[26rem] rounded-full bg-gold/10 blur-3xl" />

      <div className="relative mx-auto flex min-h-[300px] max-w-7xl items-start px-6 pt-16 pb-6 sm:min-h-[78vh] sm:items-center sm:py-28 lg:min-h-[86vh] lg:px-10">
        <div className="max-w-[60%] sm:max-w-md lg:max-w-xl">
          <p className="hero-in text-[0.55rem] font-semibold uppercase tracking-[0.22em] text-gold sm:text-xs sm:tracking-[0.32em]">
            Enhance. Elevate. Empower.
          </p>
          <p className="mt-2 sm:mt-4">
            <span className="hero-in block font-display text-2xl font-medium leading-[1.08] text-ivory sm:text-5xl xl:text-6xl">
              Effortless Beauty,
            </span>
            <span
              className="hero-in block font-script text-3xl leading-[1.15] text-gold sm:text-6xl xl:text-7xl"
              style={{ animationDelay: "0.1s" }}
            >
              Every Day.
            </span>
          </p>
          <p
            className="hero-in mt-3 max-w-[11rem] text-[0.6rem] font-light uppercase leading-relaxed tracking-[0.12em] text-ivory/80 sm:mt-5 sm:max-w-sm sm:text-sm sm:tracking-[0.18em]"
            style={{ animationDelay: "0.2s" }}
          >
            Lash, brow &amp; beauty services designed just for you.
          </p>
          <div className="hero-in mt-4 sm:mt-7" style={{ animationDelay: "0.3s" }}>
            <Link
              to="/book"
              data-testid="hero-book-btn"
              className="btn-gold inline-flex px-7 py-3 text-[0.6rem] tracking-[0.2em] uppercase sm:px-9 sm:py-3.5 sm:text-[0.7rem]"
            >
              Book Now
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
